import { createFileRoute, redirect } from '@tanstack/react-router'

import { ACCOUNT_PATHS } from '@/features/user/profile'

/** Sub-rota inexistente sob `/minha-conta` cai no perfil em vez de 404. */
export const Route = createFileRoute('/_event/minha-conta/$')({
  beforeLoad: () => {
    throw redirect({
      to: ACCOUNT_PATHS.profile,
      replace: true
    })
  }
})
